import "../scss/selfService.scss";
import { progressbar, datepicker } from "jquery-ui-dist/jquery-ui.js";
import "jquery-ui-dist/jquery-ui.css";
import "jquery-mask-plugin";
import Switchery from "../../../Fundraising.UI.Shared/Vendor/switchery/js/switchery";
import { RegistrantEmailCheck } from "../../../Fundraising.UI.Shared/Modules/account/RegistrantEmailCheck";
import { OrgNameCheck } from "../../../Fundraising.UI.Shared/Modules/account/OrgNameCheck";
import { WebCodeCheck } from "../../../Fundraising.UI.Shared/Modules/account/WebCodeCheck";
import { DatePicker } from "../../../Fundraising.UI.Shared/Modules/datePicker/TimeDatePicker";

(function ($) {
    //Decalare in Global Namespace	
    window.M2 = window.M2 || {};
    window.M2.SelfService = {};

    let isFrame, parentId, endDate_StartDateCutOff;

    const setProgressBar = () => {
        const progressBars = document.querySelectorAll(".progressbar");

        progressBars.forEach(function (progressBar) {
            const value = parseInt(progressBar.dataset.progressValue);
            $(progressBar).progressbar({ value: value });
        });
    }

    const setCountrySelector = () => {
        $(document).on("change", "#Country", function () {
            const $countrySelector = $(this);
            const country = $countrySelector.val();
            if (country == "Other") {
                $countrySelector.val("United States");
                M2.Modal.create("international-user", "We're Sorry", "#international-user-modal", "modal-md", true);
            }
        });
    }

    const resetOrgTypes = () => {
        const $typeSelectors = $(".org-type-selection");
        $typeSelectors.each(function (index) {
            const $typeSelector = $(this);
            const $radioButton = $typeSelector.find("input[type=radio]");
            const $groupTypeValue = $("#OrganizationActivityType");
            $typeSelector.removeClass("active");
            $radioButton.prop("checked", false);
            $groupTypeValue.val("");
        });
    }

    const setOrgTypeSelector = () => {
        $(document).on("click", ".org-type-selection", function (e) {
            e.preventDefault();
            const $typeSelector = $(this);
            const $radioButton = $typeSelector.find("input[type=radio]");
            const isChecked = $radioButton.is(':checked');
            const $groupTypeValue = $("#OrganizationActivityType");
            resetOrgTypes();
            if (!isChecked) {
                $typeSelector.addClass("active");
                $radioButton.prop("checked", true);
                $groupTypeValue.val($radioButton.val());
                $groupTypeValue.valid();
            }
        });
    }

    const setNonProfitSelector = () => {
        $(document).on("change", "#NonProfit", function (e) {
            const isNonProfit = $(this).val() == "Yes";
            const $taxIdContainer = $(".tax-id-container");
            if (isNonProfit) {
                $taxIdContainer.removeClass("hidden");
            } else {
                $taxIdContainer.addClass("hidden");
            }
        });
    }

    const setShowPassword = () => {
        $(document).on("click", ".form-group.password label", function (e) {
            const $container = $(this);
            const $input = $("#Password");
            if ($input.attr('type') === 'password') {
                $input.attr('type', 'text');
                $container.addClass('show-password');
            } else {
                $input.attr('type', 'password');
                $container.removeClass('show-password');
            }
        });
    }

    const setGoalMask = () => {
        $("#GoalAmount").mask("###,###,###,###", {
            reverse: true,
            onComplete: function (firstDigit, e) {
                if (firstDigit == 0) {
                    e.target.value = e.target.value.replace(/^0+/, '');
                }
                
            }
        });
    }

    const setPhoneMask = () => {
        $("#Phone").mask('000-000-0000');
    }

    const setTaxIdMask = () => {
        $("#TaxId").mask('00-0000000');
    }

    const setZipCodeMask = () => {
        $(".zip").mask('00000-0000');
    }

    const setWebCodeCheck = () => {
        const webCode = new WebCodeCheck("#UniqueCode");
        const $webCode = $("#UniqueCode");
        webCode.onComplete(function (data) {
            const codeExists = data.codeExists;
            const errorMsg = data.message;
            const $errorValidator = $webCode.closest(".form-group").find(".field-validation-valid");
            if (codeExists) $errorValidator.removeClass("field-validation-valid").addClass("field-validation-error").html(errorMsg);
        });

        webCode.onError(function (request, status, error) {
            console.log(error);
        });
    }

    const setEmailCheck = () => {
        const emailCheck = new RegistrantEmailCheck("#Email");
        const $email = $("#Email");
        emailCheck.onComplete(function (data) {
            const emailExists = data.emailExists;
            const isAdminUser = data.isAdminUser;
            const isCampaignUser = data.isCampaignUser;

            if (emailExists) {
                if (isAdminUser) {
                    $email.val("");
                    M2.Modal.create("email-exists", "Attention", "#email-taken-modal", "modal-md", true);
                }
                else if (isCampaignUser) {
                    M2.Modal.create("email-exists", "Attention", "#participant-email-modal", "modal-md", true);
                }
            }
        });

        emailCheck.onError(function (request, status, error) {
            console.log(error);
        });
    }

    const setRemainingCount = () => {
        $('.char-limit').each(function () {
            const $input = $(this);
            const charCounterSelector = $input.data("char-counter-selector");
            const $characterCounter = $(charCounterSelector);
            const limit = $input.attr('maxlength');

            $characterCounter.find("span.count").html(limit);
        });
    }

    const countChar = ($input, $characterCounter, limit) => {
        const charsEntered = $input.val();
        const maxLength = limit;
        const rawCharCount = charsEntered.length;
        const adjustedCharCount = getAdjustedCharacterCount(charsEntered);
        let remainingChars = maxLength - adjustedCharCount;

        if (remainingChars < 0) {
            $input.val(textArea.value.substr(0, maxLength - getNumLineBreaks(charsEntered)));
            remainingChars = 0;
        }

        $characterCounter.find("span.count").html(remainingChars);
    }

    const setCharacterLimitTools = () => {
        $(document).on("change, keyup", ".char-limit", function (e) {
            const $input = $(this);
            const charCounterSeletor = $input.data("char-counter-selector");
            const $characterCounter = $(charCounterSeletor);
            const limit = $input.attr('maxlength');
            countChar($input, $characterCounter, limit);
        });
    }

    const getAdjustedCharacterCount = (charsEntered) => {
        const numberOfLineBreaks = getNumLineBreaks(charsEntered);
        return charsEntered.length + numberOfLineBreaks;
    }

    const getNumLineBreaks = (charsEntered) => {
        return (charsEntered.match(/\n/g) || []).length;
    }

    const formatDate_database = (dateStr) => {
        const [month, day, year] = dateStr.split("/");
        return `${year}-${month}-${day}`;
    }

    const formatDate_datePicker = (dateStr) => {
        const [year, month, day] = dateStr.split("-");
        return `${month}/${day}/${year}`;
    }

    const setDatePicker = () => {

        const datePickers = $('.date-picker');

        // Assign our date-pickers
        datePickers.each(function () {

            const $datePicker = $(this);
            
            const isFrame = window.frameElement;
            if (isFrame) parentId = window.frameElement.id;

            $datePicker.datepicker({
                dateFormat: "mm/dd/yy",
                showAnim: "fadeIn",
                showOptions: {
                    direction: "down"
                },
                beforeShowDay: function (date) {
                    const startDate = ($datePicker.attr("id") == "CampaignEndDate" && endDate_StartDateCutOff) ? new Date(endDate_StartDateCutOff) : new Date($datePicker.attr("data-start-date-cutoff"));

                    // get each individual calendar dates
                    const currentDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
                    
                    // Check if the current date is within the allowed range
                    if (currentDate >= startDate) {
                        // Enable selectable dates
                        return [true, ""];
                    } else {
                        // Disable non-selectable dates
                        return [false, ""];
                    }
                },
                beforeShow(date, picker) {
                    // Resize iFrame if needed
                    if (parentId) resizeiFrameforDate(parentId);
                    // Check if this is the end date, and if so load up our new start date.
                    const $picker = $(date);
                    if (picker.id == "CampaignEndDate" && endDate_StartDateCutOff) $picker.datepicker("setDate", formatDate_datePicker(endDate_StartDateCutOff));
                },
                onSelect: () => {
                    selectSuccess($datePicker);
                },
                onClose: () => {
                    onClose(parentId);
                },
            });
        });
    }

    const selectSuccess = ($datePicker) => {

        function addDays(date, days) {
            date = new Date(date);
            date.setDate(date.getDate() + days);
            const newYear = date.getFullYear();
            const newMonth = (date.getMonth() + 1).toString().padStart(2, "0");
            const newDay = date.getDate().toString().padStart(2, "0"); 
            return `${newYear}-${newMonth}-${newDay}`;
        }

        $datePicker.valid();
        const isStartDate = $datePicker.attr("id") == "CampaignStartDate";

        if (isStartDate) {
            const $endDate = $("#CampaignEndDate");
            const formattedStartDate = formatDate_database($datePicker.val());
            const minCampaignLength = parseInt($endDate.data("min-campaign-length")) + 1;
            const startDateWithMinCampginLength = addDays(formattedStartDate, minCampaignLength);
            $endDate.attr("data-start-date-cutoff", startDateWithMinCampginLength);
            endDate_StartDateCutOff = startDateWithMinCampginLength;
        }
    }

    const onClose = (parentId) => {
        // Run any success methods here before user provided callback
        if (parentId) {
            resizeiFrameforDate(parentId, true);
        }
    }

    const resizeiFrameforDate = (parentId, closed) => {
        closed = closed ? closed : false;
        var newHeight;
        window.setTimeout(function () {
            var calendarHeight = $('#ui-datepicker-div').outerHeight(false);
            var iframeRef = parent.document.getElementById(parentId);

            if (closed) newHeight = iframeRef.contentWindow.document.body.scrollHeight;
            else newHeight = iframeRef.contentWindow.document.body.scrollHeight + calendarHeight;
            iframeRef.height = newHeight + "px";
        }, 100);
    }

    const setSwitchElements = () => {
        const smallSwitches = document.querySelectorAll('.switch-small');
        smallSwitches.forEach(function (checkbox) {
            const switchery = new Switchery(checkbox, { className: 'switchery small-switch' });
        });
    }

    const setOutOfSeasonModal = () => {
        $(document).on("click", ".out-of-season", function (e) {
            e.preventDefault();
            M2.Modal.create("out-season", "We're Sorry", "#fundraiser-closed-modal", "modal-md", true);
        });
    }

    const setConfirmEndDate = () => {
        $(document).on("click", ".accept-date", function (e) {
            e.preventDefault();
            const suggestedEndDate = $("#NewCampaignEndDate").val();
            window.parent.$("#CampaignEndDate").val(suggestedEndDate);
            parent.M2.Modal.close();
        });

        $(document).on("click", ".reject-date", function (e) {
            e.preventDefault();
            const $goalsForm = window.parent.$("#campaign-goals-form");
            M2.Modal.close();
            $goalsForm.trigger("submit");
        });
    }

    const setEndDateCheck = () => {
        $(document).on("click", ".check-end-date", function (e) {
            e.preventDefault();
            const participantStartDate = $("#CampaignStartDate").val();
            const participantEndDate = $("#CampaignEndDate").val();
 
            const baseURL = $(this).data("check-enddate-url");
            const checkEndDateUrl = baseURL + "?CampaignStartDate=" + participantStartDate + "&CampaignEndDate=" + participantEndDate;
            const $form = $(this).closest("form");
            // Validate the form
            if ($form.valid()) {
                $.ajax({
                    url: checkEndDateUrl
                }).done(function (data) {
                    const displayModal = data.displayModal;
                    const displayModalUrl = data.url;
                    if (displayModal) displayEndDateModal(displayModalUrl);
                    else {
                        $form.trigger("submit");
                    }
                }).fail(function (xhr, ajaxOptions, thrownError) {
                    console.log(thrownError);
                });
            }
        });
    }

    const displayEndDateModal = (endDateModalUrl) => {
        M2.Modal.create("FundraiserEndDate", "Attention", endDateModalUrl, "modal-md");
    }

    const setProductGalleryModals = () => {

        $(document).on("click", ".product-modal", function (e) {
            e.preventDefault();
            const $trigger = $(this);
            const modalId = "product-gallery";
            const modalTitle = $trigger.data("modal-title");
            const contentSrc = $trigger.data("modal-content");
            const size = "modal-md";
            const isInline = true;
            const backdrop = true;
            const delay = null;
            const allowMultiple = null;
            
            M2.Modal.create(modalId, modalTitle, contentSrc, size, isInline, backdrop, delay, allowMultiple, function () {
                const gallery = $(".modal-content .image-gallery").unslider({
                    infinite: true,
                    autoplay: false,
                    dots: true
                });
            });
        });
    }

    M2.SelfService = {
        init: function () {
            setProgressBar();
            setCountrySelector();
            setOrgTypeSelector();
            setGoalMask();
            setPhoneMask();
            setTaxIdMask();
            setZipCodeMask();
            setShowPassword();
            setEmailCheck();
            setNonProfitSelector();
            setRemainingCount();
            setCharacterLimitTools();
            setDatePicker();
            setSwitchElements();
            setOutOfSeasonModal();
            setConfirmEndDate();
            setEndDateCheck();
            setWebCodeCheck();
            setProductGalleryModals();
        }
    }
})(jQuery);

$(function () {
    M2.SelfService.init();
});

if (module.hot) {
    module.hot.accept();
}